/** 福彩3D 娱乐盘侧栏与一字定位配置（对齐参考站 play_menu/2） */

export const FC3D_GAME_ID = 14
export const FC3D_GAME_NAME = '福彩3D'

/** 左侧 / 娱乐城「更多玩法」列表（对齐抓包 pc-list） */
export const FC3D_SIDE_MENU = [
  { key: 'one-pos', label: '一字定位' },
  { key: 'one-com', label: '一字组合' },
  { key: 'two-pos', label: '二字定位' },
  { key: 'two-com', label: '二字组合' },
  { key: 'two-sum', label: '二字和数' },
  { key: 'three-pos', label: '三字定位' },
  { key: 'three-com', label: '三字组合' },
  { key: 'three-sum', label: '三字和数' },
  { key: 'group3', label: '组选三' },
  { key: 'group6', label: '组选六' },
  { key: 'span', label: '跨度' }
]

/** 官方盘「更多玩法」扁平列表（兼容查找） */
export const FC3D_TRAD_MENU = [
  { key: 't-last3-zx', label: '三星直选' },
  { key: 't-last3-zx-ds', label: '三星直选（单式）' },
  { key: 't-last3-sum', label: '三星直选和值' },
  { key: 't-last3-z3', label: '三星组三' },
  { key: 't-last3-z6', label: '三星组六' },
  { key: 't-last3-zsum', label: '三星组选和值' },
  { key: 't-last3-mix', label: '三星混合组选' },
  { key: 't-front2-zx', label: '前二直选' },
  { key: 't-front2-zx-ds', label: '前二直选（单式）' },
  { key: 't-front2-zux', label: '前二组选' },
  { key: 't-back2-zx', label: '后二直选' },
  { key: 't-back2-zx-ds', label: '后二直选（单式）' },
  { key: 't-back2-zux', label: '后二组选' },
  { key: 't-bdw1', label: '一码不定位' },
  { key: 't-bdw2', label: '二码不定位' },
  { key: 't-front2-dxds', label: '前二大小单双' },
  { key: 't-back2-dxds', label: '后二大小单双' },
  { key: 't-dw', label: '定位胆' }
]

/** 官方盘「更多玩法」分组（对齐抓包 pc-list / 参考站手风琴） */
export const FC3D_TRAD_MENU_GROUPS = [
  { key: 'quickfav', name: '快捷玩法', quick: true, children: [] },
  {
    key: 'last3',
    name: '三星',
    children: [
      { key: 't-last3-zx', name: '三星直选' },
      { key: 't-last3-zx-ds', name: '三星直选（单式）' },
      { key: 't-last3-sum', name: '三星直选和值' },
      { key: 't-last3-z3', name: '三星组三' },
      { key: 't-last3-z6', name: '三星组六' },
      { key: 't-last3-zsum', name: '三星组选和值' },
      { key: 't-last3-mix', name: '三星混合组选' }
    ]
  },
  {
    key: 'front2',
    name: '前二',
    children: [
      { key: 't-front2-zx', name: '前二直选' },
      { key: 't-front2-zx-ds', name: '前二直选（单式）' },
      { key: 't-front2-zux', name: '前二组选' }
    ]
  },
  {
    key: 'back2',
    name: '后二',
    children: [
      { key: 't-back2-zx', name: '后二直选' },
      { key: 't-back2-zx-ds', name: '后二直选（单式）' },
      { key: 't-back2-zux', name: '后二组选' }
    ]
  },
  {
    key: 'bdw',
    name: '不定位',
    children: [
      { key: 't-bdw1', name: '一码不定位' },
      { key: 't-bdw2', name: '二码不定位' }
    ]
  },
  {
    key: 'dxds',
    name: '大小单双',
    children: [
      { key: 't-front2-dxds', name: '前二大小单双' },
      { key: 't-back2-dxds', name: '后二大小单双' }
    ]
  },
  {
    key: 'dw',
    name: '定位胆',
    children: [
      { key: 't-dw', name: '定位胆' }
    ]
  }
]

export const FC3D_PLAY_MODE_TABS = [
  { key: 'tradition', name: '官方' },
  { key: 'entertainment', name: '娱乐城' }
]

export function getSheetMenu(mode) {
  return mode === 'tradition' ? FC3D_TRAD_MENU_GROUPS : FC3D_SIDE_MENU
}

export function findTradPlayLabel(key) {
  const hit = FC3D_TRAD_MENU.find((m) => m.key === key)
  return hit?.label || ''
}

export function findTradGroupByPlayKey(playKey) {
  return FC3D_TRAD_MENU_GROUPS.find(
    (g) => !g.quick && (g.children || []).some((c) => c.key === playKey)
  ) || null
}

export function isTradPlayKey(key) {
  return FC3D_TRAD_MENU.some((m) => m.key === key)
}

/** 官方三星定位位（百/十/个） */
export const FC3D_TRAD_POS = [
  { name: '百位', index: 0 },
  { name: '十位', index: 1 },
  { name: '个位', index: 2 }
]

/** 前二：百 / 十 */
export const FC3D_TRAD_FRONT2_POS = [
  { name: '百位', index: 0 },
  { name: '十位', index: 1 }
]

/** 后二：十 / 个 */
export const FC3D_TRAD_BACK2_POS = [
  { name: '十位', index: 1 },
  { name: '个位', index: 2 }
]

export const FC3D_TRAD_QUICKS = [
  { key: 'all', label: '全' },
  { key: 'big', label: '大' },
  { key: 'small', label: '小' },
  { key: 'odd', label: '奇' },
  { key: 'even', label: '偶' },
  { key: 'clear', label: '清' }
]

export const FC3D_TRAD_QUICK_MAP = {
  all: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  big: [5, 6, 7, 8, 9],
  small: [0, 1, 2, 3, 4],
  odd: [1, 3, 5, 7, 9],
  even: [0, 2, 4, 6, 8],
  clear: []
}

/** 官方玩法配置（对齐 P3 直选布局；奖金按参考站三星直选 980） */
export const FC3D_TRAD_PLAYS = {
  't-last3-zx': {
    layout: 'digit',
    mode: 'direct',
    playName: '三星直选',
    positions: FC3D_TRAD_POS,
    prize: 980,
    showMiss: true,
    showLimit: true,
    limitText: '该玩法订单投注上限：800 注',
    unit: 2,
    range: 10,
    rangeStart: 0,
    fillBalls: 3,
    requireEachRow: true
  },
  't-last3-zx-ds': {
    layout: 'text',
    mode: 'direct',
    playName: '三星直选（单式）',
    positions: FC3D_TRAD_POS,
    prize: 980,
    showMiss: false,
    showLimit: true,
    limitText: '该玩法订单投注上限：800 注',
    unit: 2,
    fillBalls: 3,
    textDigits: 3,
    placeholder: '每注之间可以用回车、空格、逗号[,]或者分号[;]、["|"]隔开，请导入TXT文件、复制或者输入支持格式如下：\n123 456\n123,456\n1+2+3;4+5+6\n1.2.3 4.5.6\n123|456'
  },
  't-last3-sum': {
    layout: 'digit',
    mode: 'direct',
    playName: '三星直选和值',
    positions: [{ name: '和值', index: 0 }],
    prize: 980,
    showMiss: false,
    showLimit: true,
    limitText: '该玩法单列投注上限：800 注',
    unit: 2,
    range: 28,
    rangeStart: 0,
    fillBalls: 1,
    requireEachRow: true,
    sumLayout: true
  },
  't-last3-z3': {
    layout: 'digit',
    mode: 'direct',
    playName: '三星组三',
    positions: [{ name: '组三', index: 0 }],
    prize: 326.66,
    showMiss: false,
    showLimit: true,
    limitText: '该玩法订单投注上限: 72 注',
    unit: 2,
    range: 10,
    rangeStart: 0,
    fillBalls: 2,
    combo: 'z3'
  },
  't-last3-z6': {
    layout: 'digit',
    mode: 'direct',
    playName: '三星组六',
    positions: [{ name: '组六', index: 0 }],
    prize: 163.33,
    showMiss: false,
    showLimit: true,
    limitText: '该玩法订单投注上限: 96 注',
    unit: 2,
    range: 10,
    rangeStart: 0,
    fillBalls: 3,
    combo: 'z6'
  },
  't-last3-zsum': {
    layout: 'digit',
    mode: 'direct',
    playName: '三星组选和值',
    positions: [{ name: '和值', index: 0 }],
    prize: 326.66,
    showMiss: false,
    showLimit: true,
    limitText: '该玩法单列投注上限：168 注',
    unit: 2,
    range: 26,
    rangeStart: 1,
    fillBalls: 1,
    requireEachRow: true,
    sumLayout: true
  },
  't-last3-mix': {
    layout: 'text',
    mode: 'group',
    playName: '三星混合组选',
    positions: FC3D_TRAD_POS,
    prize: 326.66,
    showMiss: false,
    showLimit: true,
    limitText: '该玩法订单投注上限: 792 注',
    unit: 2,
    fillBalls: 3,
    textDigits: 3,
    textMode: 'mix',
    placeholder: '每注之间可以用回车、空格、逗号[,]或者分号[;]、["|"]隔开，请导入TXT文件、复制或者输入支持格式如下：\n123 456\n123,456\n1+2+3;4+5+6\n1.2.3 4.5.6\n123|456'
  },
  't-front2-zx': {
    layout: 'digit',
    mode: 'direct',
    playName: '前二直选',
    positions: FC3D_TRAD_FRONT2_POS,
    prize: 98,
    showMiss: true,
    showLimit: true,
    limitText: '该玩法订单投注上限: 80 注',
    unit: 2,
    range: 10,
    rangeStart: 0,
    fillBalls: 2,
    requireEachRow: true,
    shapeMode: 'front2'
  },
  't-front2-zx-ds': {
    layout: 'text',
    mode: 'direct',
    playName: '前二直选（单式）',
    positions: FC3D_TRAD_FRONT2_POS,
    prize: 98,
    showMiss: false,
    showLimit: true,
    limitText: '该玩法订单投注上限: 80 注',
    unit: 2,
    fillBalls: 2,
    textDigits: 2,
    shapeMode: 'front2',
    placeholder: '每注之间可以用回车、空格、逗号[,]或者分号[;]、["|"]隔开，请导入TXT文件、复制或者输入支持格式如下：\n12 34\n12,34\n1+2;3+4\n1.2 3.4\n12|34'
  },
  't-front2-zux': {
    layout: 'digit',
    mode: 'group',
    playName: '前二组选',
    positions: [{ name: '组选', index: 0 }],
    prize: 49,
    showMiss: false,
    showLimit: true,
    limitText: '该玩法订单投注上限: 36 注',
    unit: 2,
    range: 10,
    rangeStart: 0,
    fillBalls: 2,
    hideAll: true,
    combo: 'zux2',
    shapeMode: 'front2'
  },
  't-back2-zx': {
    layout: 'digit',
    mode: 'direct',
    playName: '后二直选',
    positions: FC3D_TRAD_BACK2_POS,
    prize: 98,
    showMiss: true,
    showLimit: true,
    limitText: '该玩法订单投注上限: 80 注',
    unit: 2,
    range: 10,
    rangeStart: 0,
    fillBalls: 2,
    requireEachRow: true,
    shapeMode: 'back2'
  },
  't-back2-zx-ds': {
    layout: 'text',
    mode: 'direct',
    playName: '后二直选（单式）',
    positions: FC3D_TRAD_BACK2_POS,
    prize: 98,
    showMiss: false,
    showLimit: true,
    limitText: '该玩法订单投注上限: 80 注',
    unit: 2,
    fillBalls: 2,
    textDigits: 2,
    shapeMode: 'back2',
    placeholder: '每注之间可以用回车、空格、逗号[,]或者分号[;]、["|"]隔开，请导入TXT文件、复制或者输入支持格式如下：\n12 34\n12,34\n1+2;3+4\n1.2 3.4\n12|34'
  },
  't-back2-zux': {
    layout: 'digit',
    mode: 'group',
    playName: '后二组选',
    positions: [{ name: '组选', index: 0 }],
    prize: 49,
    showMiss: false,
    showLimit: true,
    limitText: '该玩法订单投注上限: 36 注',
    unit: 2,
    range: 10,
    rangeStart: 0,
    fillBalls: 2,
    hideAll: true,
    combo: 'zux2',
    shapeMode: 'back2'
  },
  't-bdw1': {
    layout: 'digit',
    mode: 'bdw',
    playName: '一码不定位',
    positions: [{ name: '胆码', index: 0 }],
    prize: 3.61,
    showMiss: false,
    showLimit: true,
    limitText: '该玩法订单投注上限: 8 注',
    unit: 2,
    range: 10,
    rangeStart: 0,
    fillBalls: 1,
    hideQuicks: true,
    contentFlat: true,
    requireEachRow: true
  },
  't-bdw2': {
    layout: 'digit',
    mode: 'bdw',
    playName: '二码不定位',
    positions: [
      { name: '一胆', index: 0 },
      { name: '二胆', index: 1 }
    ],
    prize: 34.9,
    prizeNonPair: 18.14,
    showMiss: false,
    showLimit: true,
    limitText: '该玩法订单投注上限: 80 注',
    unit: 2,
    range: 10,
    rangeStart: 0,
    fillBalls: 2,
    hideQuicks: true,
    requireEachRow: true,
    singlePerRow: true
  },
  't-front2-dxds': {
    layout: 'digit',
    mode: 'dxds',
    playName: '前二大小单双',
    positions: FC3D_TRAD_FRONT2_POS,
    prize: 3.92,
    showMiss: true,
    showLimit: true,
    limitText: '该玩法订单投注上限: 12 注',
    unit: 2,
    fillBalls: 2,
    hideQuicks: true,
    // 与 P3 一致：每位只选 1 个属性，两行都选后注数=1；上限指订单累计
    maxPerRow: 1,
    requireEachRow: true,
    choiceOptions: ['大', '小', '单', '双'],
    shapeMode: 'front2'
  },
  't-back2-dxds': {
    layout: 'digit',
    mode: 'dxds',
    playName: '后二大小单双',
    positions: FC3D_TRAD_BACK2_POS,
    prize: 3.92,
    showMiss: true,
    showLimit: true,
    limitText: '该玩法订单投注上限: 12 注',
    unit: 2,
    fillBalls: 2,
    hideQuicks: true,
    maxPerRow: 1,
    requireEachRow: true,
    choiceOptions: ['大', '小', '单', '双'],
    shapeMode: 'back2'
  },
  't-dw': {
    layout: 'digit',
    mode: 'position',
    playName: '定位胆',
    positions: FC3D_TRAD_POS,
    prize: 9.8,
    showMiss: true,
    showLimit: true,
    limitText: '该玩法单列投注上限：8 注',
    unit: 2,
    range: 10,
    rangeStart: 0,
    fillBalls: 1,
    maxPerRow: 8,
    countMode: 'sum'
  }
}

export function getTradPlayConfig(key) {
  return FC3D_TRAD_PLAYS[key] || null
}

/** 一字定位：百 / 十 / 个 */
export const ONE_POS_TABS = [
  { key: 'bai', label: '百定位', prefix: 'bai' },
  { key: 'shi', label: '十定位', prefix: 'shi' },
  { key: 'ge', label: '个定位', prefix: 'ge' }
]

const DIGIT_ODDS = '9.8'
const ATTR_ODDS = '1.96'

function digitOptions(prefix) {
  return Array.from({ length: 10 }, (_, i) => ({
    key: `${prefix}-n${i}`,
    name: String(i),
    label: String(i),
    odds: DIGIT_ODDS,
    kind: 'digit',
    value: i
  }))
}

function bsoeOptions(prefix) {
  return [
    { key: `${prefix}-big`, name: '大', odds: ATTR_ODDS, kind: 'bsoe', value: 'BIG' },
    { key: `${prefix}-small`, name: '小', odds: ATTR_ODDS, kind: 'bsoe', value: 'SMALL' },
    { key: `${prefix}-odd`, name: '单', odds: ATTR_ODDS, kind: 'bsoe', value: 'ODD' },
    { key: `${prefix}-even`, name: '双', odds: ATTR_ODDS, kind: 'bsoe', value: 'EVEN' }
  ]
}

function primeOptions(prefix) {
  return [
    { key: `${prefix}-prime`, name: '质数', odds: ATTR_ODDS, kind: 'prime', value: 'PRIME' },
    { key: `${prefix}-comp`, name: '合数', odds: ATTR_ODDS, kind: 'prime', value: 'COMPOSITE' }
  ]
}

export function buildOnePosOptions(tabKey) {
  const tab = ONE_POS_TABS.find((t) => t.key === tabKey) || ONE_POS_TABS[0]
  const p = tab.prefix
  return {
    digits: digitOptions(p),
    bsoe: bsoeOptions(p),
    prime: primeOptions(p),
    all: [...digitOptions(p), ...bsoeOptions(p), ...primeOptions(p)]
  }
}

/** 一字组合：任选号码，开奖三位中含该号即中（赔率 3.61） */
const ONE_COM_ODDS = '3.61'

export function buildOneComOptions() {
  return Array.from({ length: 10 }, (_, i) => ({
    key: `onecom-n${i}`,
    name: String(i),
    label: String(i),
    odds: ONE_COM_ODDS,
    kind: 'digit',
    value: i
  }))
}

export const ONE_POS_HELP = {
  title: '一字定位',
  lines: [
    '从百位、十位、个位任意位置选择一个号码进行投注。',
    '所选号码与开奖号码对应位置一致即中奖。',
    '亦可投注该位大小单双、质数合数：',
    '大：5–9；小：0–4；单：1/3/5/7/9；双：0/2/4/6/8；',
    '质数：1/2/3/5/7；合数：0/4/6/8/9。'
  ]
}

export const ONE_COM_HELP = {
  title: '一字组合',
  lines: [
    '从 0–9 中选择一个或多个号码投注。',
    '开奖号码（百、十、个三位）中只要出现所选号码即中奖。',
    '不限位置；同一号码在开奖号中出现多次仍按该玩法规则结算。'
  ]
}

/** 二字定位：百十 / 百个 / 十个（对齐 Hundreds_Tens / Hundreds_Units / Tens_Units） */
export const TWO_POS_TABS = [
  { key: 'bs', label: '百十定位', pattern: 'nnx' },
  { key: 'bg', label: '百个定位', pattern: 'nxn' },
  { key: 'sg', label: '十个定位', pattern: 'xnn' }
]

const TWO_POS_ODDS = '98'

function formatTwoPosLabel(pattern, a, b) {
  const da = String(a)
  const db = String(b)
  if (pattern === 'nnx') return `${da}${db}x`
  if (pattern === 'nxn') return `${da}x${db}`
  return `x${da}${db}`
}

export function buildTwoPosOptions(tabKey) {
  const tab = TWO_POS_TABS.find((t) => t.key === tabKey) || TWO_POS_TABS[0]
  const list = []
  for (let a = 0; a < 10; a++) {
    for (let b = 0; b < 10; b++) {
      const label = formatTwoPosLabel(tab.pattern, a, b)
      list.push({
        key: `twopos-${tab.key}-${a}${b}`,
        name: label,
        label,
        odds: TWO_POS_ODDS,
        kind: 'two-pos',
        value: `${a}_${b}`,
        a,
        b
      })
    }
  }
  return list
}

export const TWO_POS_HELP = {
  title: '二字定位',
  lines: [
    '百十定位：从百位及十位 0–9 各自任选 1 个号共 2 号码组合投注，开奖结果与所选号码相同且顺序一致即中奖。',
    '百个定位：从百位及个位 0–9 各自任选 1 个号共 2 号码组合投注，开奖结果与所选号码相同且顺序一致即中奖。',
    '十个定位：从十位及个位 0–9 各自任选 1 个号共 2 号码组合投注，开奖结果与所选号码相同且顺序一致即中奖。'
  ]
}

/** 二字组合：00–99；对子 34.98，异号 18.13（对齐 Two_Word_Combine R#2 / R#1） */
const TWO_COM_PAIR_ODDS = '34.98'
const TWO_COM_DIFF_ODDS = '18.13'

export function buildTwoComOptions() {
  const list = []
  for (let a = 0; a < 10; a++) {
    for (let b = 0; b < 10; b++) {
      const label = `${a}${b}`
      const pair = a === b
      list.push({
        key: `twocom-${label}`,
        name: label,
        label,
        odds: pair ? TWO_COM_PAIR_ODDS : TWO_COM_DIFF_ODDS,
        kind: 'two-com',
        value: pair ? 'R#2' : 'R#1',
        a,
        b,
        pair
      })
    }
  }
  return list
}

export const TWO_COM_HELP = {
  title: '二字组合',
  lines: [
    '第一码及第二码 0–9 各自任选 1 个号共 2 个号码投注，开奖结果百十个任二数与所选号码相同即中奖（不限顺序）。',
    '同号（如 11）：开奖为 11x、1x1、x11 皆中奖。',
    '异号（如 12）：开奖为 12x、1x2、21x、2x1、x12、x21 皆中奖。',
    '同号与异号赔率不同。'
  ]
}

/** 二字和数：百十 / 百个 / 十个；和数 0–18 + 尾数 0–9 */
export const TWO_SUM_TABS = [
  { key: 'bs', label: '百十和数', sumTitle: '百十和数', tailTitle: '百十和数尾数' },
  { key: 'bg', label: '百个和数', sumTitle: '百个和数', tailTitle: '百个和数尾数' },
  { key: 'sg', label: '十个和数', sumTitle: '十个和数', tailTitle: '十个和数尾数' }
]

const TWO_SUM_ODDS = [
  '98', '49', '32.66', '24.5', '19.6', '16.32', '13.99', '12.25', '10.88', '9.8',
  '10.88', '12.25', '13.99', '16.32', '19.6', '24.5', '32.66', '49', '98'
]
const TWO_SUM_TAIL_ODDS = '9.8'

export function buildTwoSumOptions(tabKey) {
  const tab = TWO_SUM_TABS.find((t) => t.key === tabKey) || TWO_SUM_TABS[0]
  const sum = TWO_SUM_ODDS.map((odds, i) => ({
    key: `twosum-${tab.key}-s${i}`,
    name: String(i),
    label: String(i),
    odds,
    kind: 'two-sum',
    section: 'sum',
    value: String(i)
  }))
  const tail = Array.from({ length: 10 }, (_, i) => ({
    key: `twosum-${tab.key}-t${i}`,
    name: String(i),
    label: String(i),
    odds: TWO_SUM_TAIL_ODDS,
    kind: 'two-sum-tail',
    section: 'tail',
    value: String(i)
  }))
  return { sum, tail, all: [...sum, ...tail], tab }
}

export const TWO_SUM_HELP = {
  title: '二字和数',
  lines: [
    '百十和数：从 0–18 中选择号码，所选数值等于开奖百位与十位相加之和即中奖。',
    '百十和数尾数：从 0–9 中选择，等于百十和的个位数即中奖。',
    '百个和数 / 十个和数及其尾数规则同理，分别对应百+个、十+个。'
  ]
}

/** 三字定位：百位页签 000/100/…/900，每页 100 号，赔率 980 */
export const THREE_POS_TABS = Array.from({ length: 10 }, (_, i) => ({
  key: String(i),
  label: `${i}00`,
  hundred: i
}))

const THREE_POS_ODDS = '980'

export function buildThreePosOptions(tabKey) {
  const tab = THREE_POS_TABS.find((t) => t.key === String(tabKey)) || THREE_POS_TABS[0]
  const h = tab.hundred
  const list = []
  for (let t = 0; t < 10; t++) {
    for (let u = 0; u < 10; u++) {
      const label = `${h}${t}${u}`
      list.push({
        key: `threepos-${label}`,
        name: label,
        label,
        odds: THREE_POS_ODDS,
        kind: 'three-pos',
        value: `${h}_${t}_${u}`,
        a: h,
        b: t,
        c: u
      })
    }
  }
  return list
}

export const THREE_POS_HELP = {
  title: '三字定位',
  lines: [
    '从百位、十位、个位 0–9 各自任选 1 个号共 3 号码组合投注。',
    '开奖结果与所选号码相同且顺序一致即中奖。'
  ]
}

/** 三字组合：同页签 000–900；豹子 980 / 组三 326.66 / 组六 163.33（R#3/R#2/R#1） */
export const THREE_COM_TABS = THREE_POS_TABS

function threeComMeta(a, b, c) {
  const size = new Set([a, b, c]).size
  if (size === 1) return { odds: '980', value: 'R#3', form: 'bao' }
  if (size === 2) return { odds: '326.66', value: 'R#2', form: 'z3' }
  return { odds: '163.33', value: 'R#1', form: 'z6' }
}

export function buildThreeComOptions(tabKey) {
  const tab = THREE_COM_TABS.find((t) => t.key === String(tabKey)) || THREE_COM_TABS[0]
  const h = tab.hundred
  const list = []
  for (let t = 0; t < 10; t++) {
    for (let u = 0; u < 10; u++) {
      const label = `${h}${t}${u}`
      const meta = threeComMeta(h, t, u)
      list.push({
        key: `threecom-${label}`,
        name: label,
        label,
        odds: meta.odds,
        kind: 'three-com',
        value: meta.value,
        form: meta.form,
        a: h,
        b: t,
        c: u
      })
    }
  }
  return list
}

export const THREE_COM_HELP = {
  title: '三字组合',
  lines: [
    '三字同号（如 111）：开奖与所选号码相同即中奖。',
    '组三（如 112，恰有两位相同）：开奖与所选号码相同但顺序不限即中奖。',
    '组六（如 123，三位均不同）：开奖与所选号码相同但顺序不限即中奖。',
    '三种形态赔率不同。'
  ]
}

/** 三字和数：百十个和数 0–27 + 尾数 0–9（对齐 Three_Word_Total_Sum_LF） */
const THREE_SUM_ODDS = [
  '980', '326.66', '163.32', '98', '65.32', '46.65', '34.99', '27.21',
  '21.77', '17.81', '15.55', '14.2', '13.32', '13.03',
  '13.03', '13.32', '14.2', '15.55', '17.81', '21.77',
  '27.21', '34.99', '46.65', '65.32', '98', '163.32', '326.66', '980'
]
const THREE_SUM_TAIL_ODDS = '9.8'

export function buildThreeSumOptions() {
  const sum = THREE_SUM_ODDS.map((odds, i) => ({
    key: `threesum-s${i}`,
    name: String(i),
    label: String(i),
    odds,
    kind: 'three-sum',
    section: 'sum',
    value: String(i)
  }))
  const tail = Array.from({ length: 10 }, (_, i) => ({
    key: `threesum-t${i}`,
    name: String(i),
    label: String(i),
    odds: THREE_SUM_TAIL_ODDS,
    kind: 'three-sum-tail',
    section: 'tail',
    value: String(i)
  }))
  return {
    sum,
    tail,
    all: [...sum, ...tail],
    sumTitle: '百十个和数',
    tailTitle: '百十个和数尾数'
  }
}

export const THREE_SUM_HELP = {
  title: '三字和数',
  lines: [
    '百十个和数：从 0–27 中选择号码，所选数值等于开奖百、十、个三位数字之和即中奖。',
    '百十个和数尾数：从 0–9 中选择，等于百十个和的个位数即中奖。'
  ]
}

/** 组选三：选号 ≥2，注数 n×(n-1)；赔率随所选个数变化（对齐 Hundreds_Tens_Units_Com3_LF） */
export const GROUP3_DIGIT_OPTIONS = Array.from({ length: 10 }, (_, i) => ({
  key: `g3-${i}`,
  name: String(i),
  value: i
}))

export const GROUP3_ODDS_BY_COUNT = {
  5: '16.32',
  6: '10.88',
  7: '7.77',
  8: '5.83',
  9: '4.5',
  10: '3.62'
}

export function group3BetCount(n) {
  const c = Number(n) || 0
  return c >= 2 ? c * (c - 1) : 0
}

export function group3OddsText(n) {
  const odds = GROUP3_ODDS_BY_COUNT[Number(n)]
  if (!odds) return '0.0000'
  const num = Number(odds)
  return Number.isFinite(num) ? num.toFixed(4) : '0.0000'
}

export const GROUP3_HELP = {
  title: '组选三',
  lines: [
    '从 0–9 中选择至少 2 个号码组成复式投注。',
    '注数 = 所选号码个数 n × (n − 1)。',
    '开奖号码为组三形态（两位相同、一位不同），且与所选号码相符（不限顺序）即中奖。',
    '所选号码达到 5 个及以上时显示对应赔率。'
  ]
}

/** 组选六：选号 ≥3，注数 C(n,3)；赔率随所选个数变化（对齐 Hundreds_Tens_Units_Com6_LF） */
export const GROUP6_DIGIT_OPTIONS = GROUP3_DIGIT_OPTIONS.map((o) => ({
  ...o,
  key: `g6-${o.value}`
}))

export const GROUP6_ODDS_BY_COUNT = {
  4: '40.82',
  5: '16.32',
  6: '8.16',
  7: '4.66',
  8: '2.91'
}

export function group6BetCount(n) {
  const c = Number(n) || 0
  if (c < 3) return 0
  return (c * (c - 1) * (c - 2)) / 6
}

/** 前二/后二组选：注数 C(n, 2) */
export function front2ZuxBetCount(n) {
  const c = Number(n) || 0
  if (c < 2) return 0
  return (c * (c - 1)) / 2
}

export function group6OddsText(n) {
  const odds = GROUP6_ODDS_BY_COUNT[Number(n)]
  if (!odds) return '0.0000'
  const num = Number(odds)
  return Number.isFinite(num) ? num.toFixed(4) : '0.0000'
}

export const GROUP6_HELP = {
  title: '组选六',
  lines: [
    '从 0–9 中选择至少 3 个号码组成复式投注。',
    '注数 = C(n, 3) = n × (n − 1) × (n − 2) / 6。',
    '开奖号码为组六形态（三位均不同），且与所选号码相符（不限顺序）即中奖。',
    '所选号码达到 4 个及以上时显示对应赔率。'
  ]
}

/** 跨度：百十个 / 百十 / 百个 / 十个（对齐 *Span_LF） */
export const SPAN_TABS = [
  { key: 'bsg', label: '百十个跨度' },
  { key: 'bs', label: '百十跨度' },
  { key: 'bg', label: '百个跨度' },
  { key: 'sg', label: '十个跨度' }
]

const SPAN_BSG_ODDS = ['98', '18.13', '10.19', '7.77', '6.8', '6.52', '6.8', '7.77', '10.19', '18.13']
const SPAN_TWO_ODDS = ['9.8', '5.43', '6.12', '6.99', '8.16', '9.8', '12.25', '16.32', '24.5', '49']

export function buildSpanOptions(tabKey) {
  const tab = SPAN_TABS.find((t) => t.key === tabKey) || SPAN_TABS[0]
  const oddsList = tab.key === 'bsg' ? SPAN_BSG_ODDS : SPAN_TWO_ODDS
  return oddsList.map((odds, i) => ({
    key: `span-${tab.key}-${i}`,
    name: String(i),
    label: String(i),
    odds,
    kind: 'span',
    value: String(i)
  }))
}

export const SPAN_HELP = {
  title: '跨度',
  lines: [
    '百十个跨度：所选数值等于开奖百、十、个三位中最大数与最小数之差即中奖。',
    '百十跨度：等于开奖百位与十位之差（取绝对值）即中奖。',
    '百个跨度 / 十个跨度规则同理，分别对应百与个、十与个。'
  ]
}

const LAST3_ZX_HELP = {
  title: '三星直选',
  lines: [
    '从百位、十位、个位中选择一个3位数号码组成一注，所选号码与开奖号码相同，且顺序一致，即为中奖。如：百位选择1，十位选择2，个位选择3，开奖号码为123，即为中奖。',
    `单注奖金 ${FC3D_TRAD_PLAYS['t-last3-zx'].prize} U。`
  ]
}

const LAST3_ZX_DS_HELP = {
  title: '三星直选（单式）',
  lines: [
    '手动输入或导入三位数号码，每注一个三位号码（如 123）。',
    '可用回车、空格、逗号、分号或竖线分隔多注。',
    '所选号码与开奖号码按位相符即中奖。',
    `单注奖金 ${FC3D_TRAD_PLAYS['t-last3-zx-ds'].prize} U。`
  ]
}

const LAST3_SUM_HELP = {
  title: '三星直选和值',
  lines: [
    '选择一个或多个和值（0–27），开奖百、十、个三位之和与所选和值相同即中奖。',
    '例如开奖 8、5、1，和值为 14，投注 14 即中奖。',
    `玩法奖金 ${FC3D_TRAD_PLAYS['t-last3-sum'].prize} U。`
  ]
}

const LAST3_Z3_HELP = {
  title: '三星组三',
  lines: [
    '从0-9中选择2个或多个号码投注，所选号码与开奖号码的百位、十位、个位中有任意两位数字相同 (对子加单码形态)，且顺序不限，即为中奖。',
    '如：选择12，开奖号码为122，212，221，112，121，211，即为中奖。',
    `玩法奖金 ${FC3D_TRAD_PLAYS['t-last3-z3'].prize} U。注数 = n × (n − 1)。`
  ]
}

const LAST3_Z6_HELP = {
  title: '三星组六',
  lines: [
    '从0-9中选择3个或多个号码投注，所选号码与开奖号码的百位、十位、个位相同（三位均不相同），且顺序不限，即为中奖。',
    '如：选择123，开奖号码为123，132，213，231，312，321，即为中奖。',
    `玩法奖金 ${FC3D_TRAD_PLAYS['t-last3-z6'].prize} U。注数 = C(n, 3) = n × (n − 1) × (n − 2) / 6。`
  ]
}

const LAST3_ZSUM_HELP = {
  title: '三星组选和值',
  lines: [
    '选择一个或多个和值（1–26），开奖号码为组三或组六形态，且百、十、个三位之和与所选和值相同即中奖。',
    '例如开奖 8、5、1（组六），和值为 14，投注 14 即中奖。',
    `玩法奖金 ${FC3D_TRAD_PLAYS['t-last3-zsum'].prize} U。`
  ]
}

const LAST3_MIX_HELP = {
  title: '三星混合组选',
  lines: [
    '手动输入或导入三位数号码，每注一个三位号码（如 123、112）。',
    '可用回车、空格、逗号、分号或竖线分隔多注。豹子号（如 111）无效。',
    '开奖为组三或组六形态，且与所选号码相符（顺序不限）即中奖。',
    `玩法奖金 ${FC3D_TRAD_PLAYS['t-last3-mix'].prize} U。`
  ]
}

const FRONT2_ZX_HELP = {
  title: '前二直选',
  lines: [
    '从百位、十位各选一个或多个号码组成一注。',
    '所选号码与开奖号码的百位、十位按位相符（顺序一致）即中奖。',
    `玩法奖金 ${FC3D_TRAD_PLAYS['t-front2-zx'].prize} U。`
  ]
}

const FRONT2_ZX_DS_HELP = {
  title: '前二直选（单式）',
  lines: [
    '手动输入或导入两位数号码，每注对应开奖百位、十位（如 12）。',
    '可用回车、空格、逗号、分号或竖线分隔多注。',
    '所选号码与开奖号码的百位、十位按位相符即中奖。',
    `玩法奖金 ${FC3D_TRAD_PLAYS['t-front2-zx-ds'].prize} U。`
  ]
}

const FRONT2_ZUX_HELP = {
  title: '前二组选',
  lines: [
    '从0-9中选择2个或多个号码投注，所选号码与开奖号码的百位、十位相同（顺序不限）即中奖。',
    '如：选择12，开奖号码百十位为12或21，即为中奖。',
    `玩法奖金 ${FC3D_TRAD_PLAYS['t-front2-zux'].prize} U。注数 = C(n, 2) = n × (n − 1) / 2。`
  ]
}

const BACK2_ZX_HELP = {
  title: '后二直选',
  lines: [
    '从十位、个位各选一个或多个号码组成一注。',
    '所选号码与开奖号码的十位、个位按位相符（顺序一致）即中奖。',
    `玩法奖金 ${FC3D_TRAD_PLAYS['t-back2-zx'].prize} U。`
  ]
}

const BACK2_ZX_DS_HELP = {
  title: '后二直选（单式）',
  lines: [
    '手动输入或导入两位数号码，每注对应开奖十位、个位（如 12）。',
    '可用回车、空格、逗号、分号或竖线分隔多注。',
    '所选号码与开奖号码的十位、个位按位相符即中奖。',
    `玩法奖金 ${FC3D_TRAD_PLAYS['t-back2-zx-ds'].prize} U。`
  ]
}

const BACK2_ZUX_HELP = {
  title: '后二组选',
  lines: [
    '从0-9中选择2个或多个号码投注，所选号码与开奖号码的十位、个位相同（顺序不限）即中奖。',
    '如：选择12，开奖号码十个位为12或21，即为中奖。',
    `玩法奖金 ${FC3D_TRAD_PLAYS['t-back2-zux'].prize} U。注数 = C(n, 2) = n × (n − 1) / 2。`
  ]
}

const BDW1_HELP = {
  title: '一码不定位',
  lines: [
    '从0-9中选择1个或多个胆码投注。',
    '开奖号码的百位、十位、个位中任意一位与所选胆码相同即中奖（不限位置）。',
    `玩法奖金 ${FC3D_TRAD_PLAYS['t-bdw1'].prize} U。`
  ]
}

const BDW2_HELP = {
  title: '二码不定位',
  lines: [
    '在一胆、二胆中各选 1 个号码组成一注。',
    '开奖号码的百、十、个三位中包含所选两个胆码（不限位置与顺序）即中奖。',
    `玩法奖金 ${FC3D_TRAD_PLAYS['t-bdw2'].prize} U。`
  ]
}

const FRONT2_DXDS_HELP = {
  title: '前二大小单双',
  lines: [
    '对百位、十位分别选择大、小、单、双。',
    '大：5–9；小：0–4；单：1/3/5/7/9；双：0/2/4/6/8。',
    '所选属性与开奖百位、十位按位相符即中奖。',
    `玩法奖金 ${FC3D_TRAD_PLAYS['t-front2-dxds'].prize} U。`
  ]
}

const BACK2_DXDS_HELP = {
  title: '后二大小单双',
  lines: [
    '对十位、个位分别选择大、小、单、双。',
    '大：5–9；小：0–4；单：1/3/5/7/9；双：0/2/4/6/8。',
    '所选属性与开奖十位、个位按位相符即中奖。',
    `玩法奖金 ${FC3D_TRAD_PLAYS['t-back2-dxds'].prize} U。`
  ]
}

const DW_HELP = {
  title: '定位胆',
  lines: [
    '从百位、十位、个位任意位置上至少选择1个号码投注，所选号码与相同位置上的开奖号码一致，即为中奖。如：十位选择4，开奖号码为*4*，即为中奖。',
    `玩法奖金 ${FC3D_TRAD_PLAYS['t-dw'].prize} U。单列上限 8 注。`
  ]
}

export function getPlayHelp(menuKey) {
  if (menuKey === 'one-com') return ONE_COM_HELP
  if (menuKey === 'two-pos') return TWO_POS_HELP
  if (menuKey === 'two-com') return TWO_COM_HELP
  if (menuKey === 'two-sum') return TWO_SUM_HELP
  if (menuKey === 'three-pos') return THREE_POS_HELP
  if (menuKey === 'three-com') return THREE_COM_HELP
  if (menuKey === 'three-sum') return THREE_SUM_HELP
  if (menuKey === 'group3') return GROUP3_HELP
  if (menuKey === 'group6') return GROUP6_HELP
  if (menuKey === 'span') return SPAN_HELP
  if (menuKey === 't-last3-zx') return LAST3_ZX_HELP
  if (menuKey === 't-last3-zx-ds') return LAST3_ZX_DS_HELP
  if (menuKey === 't-last3-sum') return LAST3_SUM_HELP
  if (menuKey === 't-last3-z3') return LAST3_Z3_HELP
  if (menuKey === 't-last3-z6') return LAST3_Z6_HELP
  if (menuKey === 't-last3-zsum') return LAST3_ZSUM_HELP
  if (menuKey === 't-last3-mix') return LAST3_MIX_HELP
  if (menuKey === 't-front2-zx') return FRONT2_ZX_HELP
  if (menuKey === 't-front2-zx-ds') return FRONT2_ZX_DS_HELP
  if (menuKey === 't-front2-zux') return FRONT2_ZUX_HELP
  if (menuKey === 't-back2-zx') return BACK2_ZX_HELP
  if (menuKey === 't-back2-zx-ds') return BACK2_ZX_DS_HELP
  if (menuKey === 't-back2-zux') return BACK2_ZUX_HELP
  if (menuKey === 't-bdw1') return BDW1_HELP
  if (menuKey === 't-bdw2') return BDW2_HELP
  if (menuKey === 't-front2-dxds') return FRONT2_DXDS_HELP
  if (menuKey === 't-back2-dxds') return BACK2_DXDS_HELP
  if (menuKey === 't-dw') return DW_HELP
  return ONE_POS_HELP
}

/** 官方盘「游戏说明」玩法规则 Tab（对齐 P3/P5 结构） */
export const FC3D_TRAD_PLAY_HELP = {
  't-last3-zx': {
    title: '三星直选',
    desc: '从百位、十位、个位中选择一个3位数号码组成一注，所选号码与开奖号码相同，且顺序一致，即为中奖。如：百位选择1，十位选择2，个位选择3，开奖号码为123，即为中奖。'
  },
  't-last3-zx-ds': {
    title: '三星直选（单式）',
    desc: '手动输入一个3位数号码组成一注，所选号码与开奖号码相同，且顺序一致，即为中奖。如：手动输入123，开奖号码为123，即为中奖。'
  },
  't-last3-sum': {
    title: '三星直选和值',
    desc: '从 0-27 中选择1个或多个号码投注，所选数值等于开奖号码的个位、十位、百位，三个数字相加之和，即中奖。如：选择1，开奖号码是001, 010, 100，即为中奖。'
  },
  't-last3-z3': {
    title: '三星组三',
    desc: '从0-9中选择2个或多个号码投注，所选号码与开奖号码的百位、十位、个位中有任意两位数字相同（对子加单码形态），且顺序不限，即为中奖。如：选择12，开奖号码为122，212，221，112，121，211，即为中奖。'
  },
  't-last3-z6': {
    title: '三星组六',
    desc: '从0-9中选择3个或多个号码投注，所选号码与开奖号码的百位、十位、个位相同，顺序不限，即为中奖。如：选择123，开奖号码为123，132，231，213，312，321，即为中奖。'
  },
  't-last3-zsum': {
    title: '三星组选和值',
    desc: '从1-26中选择1个或多个号码投注，所选数值等于开奖号码百位、十位、个位三个数字相加之和，即为中奖(不含豹子号)。如：选择6，开奖号码为114即中组三奖，开奖号码为015即中组六奖。'
  },
  't-last3-mix': {
    title: '三星混合组选',
    desc: '输入购买号码，3个数字为一注，所选号码与开奖号码的百位、十位、个位相同，顺序不限，即为中奖。如：选择123、455，开奖号码为321即中组六奖，开奖号码为545即中组三奖。'
  },
  't-front2-zx': {
    title: '前二直选',
    desc: '从百位、十位中各选择1个或多个号码投注，所选号码与开奖号码的百位、十位相同，且顺序一致，即为中奖。如：百位选择3，十位选择4，开奖号码为34*，即为中奖。'
  },
  't-front2-zx-ds': {
    title: '前二直选（单式）',
    desc: '手动输入一个2位数号码组成一注，所选号码与开奖号码的百位、十位相同，且顺序一致，即为中奖。如：手动输入12，开奖号码为12*，即为中奖。'
  },
  't-front2-zux': {
    title: '前二组选',
    desc: '从0-9中选择2个或多个号码投注，所选号码与开奖号码的百位、十位相同，顺序不限，即为中奖。如：选择7，8，开奖号码为78*，87*，即为中奖。'
  },
  't-back2-zx': {
    title: '后二直选',
    desc: '从十位、个位中各选择1个或多个号码投注，所选号码与开奖号码的十位、个位相同，且顺序一致，即为中奖。如：十位选择3，个位选择4，开奖号码为*34，即为中奖。'
  },
  't-back2-zx-ds': {
    title: '后二直选（单式）',
    desc: '手动输入一个2位数号码组成一注，所选号码与开奖号码的十位、个位相同，且顺序一致，即为中奖。如：手动输入12，开奖号码为*12，即为中奖。'
  },
  't-back2-zux': {
    title: '后二组选',
    desc: '从0-9中选择2个或多个号码投注，所选号码与开奖号码的十位、个位相同，顺序不限，即为中奖。如：选择7、8，开奖号码为*78或*87，即为中奖。'
  },
  't-bdw1': {
    title: '一码不定位',
    desc: '从0-9中选择1个或多个号码投注，只要开奖号码的百位、十位、个位中包含所选号码，即为中奖。如：选择4，开奖号码为4**、*4*、**4，即为中奖。若开奖结果出现重复数字，则只会派奖一次不累加。'
  },
  't-bdw2': {
    title: '二码不定位',
    desc: '在一胆、二胆中各选择1个号码投注；若开奖号码的百位、十位、个位中同时包含所选的2个号码，即视为中奖（包含对子情况；若开奖号码为豹子号，则按对子规则派彩）。例如：一胆、二胆均选5，开奖号码含对子5即中对子奖；一胆选4、二胆选5，开奖号码含4与5即中非对子奖。'
  },
  't-front2-dxds': {
    title: '前二大小单双',
    desc: '从百位、十位中的“大(56789)、小(01234)、单(13579)、双(02468)”中选择1个或多个投注，所选号码与开奖号码的位置、形态相同，即为中奖。如：百位选择大，十位选择单，开奖号码为63*，即为中奖。'
  },
  't-back2-dxds': {
    title: '后二大小单双',
    desc: '从十位、个位中的“大(56789)、小(01234)、单(13579)、双(02468)”中选择1个或多个投注，所选号码与开奖号码的位置、形态相同，即为中奖。如：十位选择小，个位选择双，开奖号码为*12，即为中奖。'
  },
  't-dw': {
    title: '定位胆',
    desc: '从百位、十位、个位任意位置上至少选择1个号码投注，所选号码与相同位置上的开奖号码一致，即为中奖。如：十位选择4，开奖号码为*4*，即为中奖。'
  }
}

export function getTradPlayHelp(playKey) {
  const preset = FC3D_TRAD_PLAY_HELP[playKey]
  if (preset) return preset
  const h = getPlayHelp(playKey)
  return {
    title: h.title || '玩法说明',
    desc: (h.lines || []).filter((line) => !/^单注奖金|^玩法奖金/.test(line)).join('')
  }
}

/** 奖金总览固定上限（福彩3D） */
export const FC3D_PRIZE_CAPS = {
  periodMax: 400000,
  betMax: 200000,
  stakeMax: 100000
}

/** 多档玩法奖金总览（组选和值 / 混合组选等） */
export const FC3D_TRAD_PRIZE_ROWS = {
  't-last3-zsum': [
    { label: '组三:', value: Number(FC3D_TRAD_PLAYS['t-last3-z3'].prize).toFixed(4) },
    { label: '组六:', value: Number(FC3D_TRAD_PLAYS['t-last3-z6'].prize).toFixed(4) }
  ],
  't-last3-mix': [
    { label: '组三:', value: Number(FC3D_TRAD_PLAYS['t-last3-z3'].prize).toFixed(4) },
    { label: '组六:', value: Number(FC3D_TRAD_PLAYS['t-last3-z6'].prize).toFixed(4) }
  ],
  't-bdw2': [
    { label: '对子:', value: Number(FC3D_TRAD_PLAYS['t-bdw2'].prize).toFixed(4) },
    { label: '非对子:', value: Number(FC3D_TRAD_PLAYS['t-bdw2'].prizeNonPair).toFixed(4) }
  ]
}

export function getTradPrizeRows(playKey) {
  return FC3D_TRAD_PRIZE_ROWS[playKey] || []
}

/** 彩种说明 */
export const FC3D_LOTTERY_HELP = {
  schedules: [{ time: '21:15:00', freq: '每天1期，24小时一期' }],
  intro:
    '此彩种来源于中国福利彩票发行中心统一发行彩票3D游戏。福彩3D每日北京时间21:15 在中国教育电视台一套直播开奖，每期结果将由000~999中随机开出奖号。由左到右分别为百、十、个位。当开奖号码出现连续2期（含）以上相同奖号，此时平台有权从相同期开始的投注撤单处理。',
  live: { label: '福彩开奖直播', url: 'https://www.cwl.gov.cn/ygkj/kjzb/' },
  official: { label: '中国福利彩票发行管理中心', url: 'https://www.cwl.gov.cn/' },
  ref: 'https://278250.com/#/DPC/FC3D/'
}

/** 开奖形态：豹子 / 组三 / 组六 */
export function fc3dDrawShapeLabel(codes) {
  const arr = (codes || []).map((n) => Number(n)).filter((n) => Number.isFinite(n))
  if (arr.length < 3) return ''
  const [a, b, c] = arr
  if (a === b && b === c) return '豹子'
  if (a === b || b === c || a === c) return '组三'
  return '组六'
}

/** 前二形态：对子 / 组二（看百、十） */
export function fc3dFront2ShapeLabel(codes) {
  const arr = (codes || []).map((n) => Number(n)).filter((n) => Number.isFinite(n))
  if (arr.length < 2) return ''
  return arr[0] === arr[1] ? '对子' : '组二'
}

/** 后二形态：对子 / 组二（看十、个） */
export function fc3dBack2ShapeLabel(codes) {
  const arr = (codes || []).map((n) => Number(n)).filter((n) => Number.isFinite(n))
  if (arr.length < 3) return ''
  return arr[1] === arr[2] ? '对子' : '组二'
}

/** 路子图：整合 Tab + 百/十/个 × 定位·大小·单双·质合 */
export const ROAD_MAIN_TABS_FC3D = [
  { key: 'combine', label: '整合' }
]

export const ROAD_FILTERS_FC3D = [
  { key: 'bai-pos', label: '百定位', pos: 0, mode: 'pos' },
  { key: 'bai-bs', label: '百大小', pos: 0, mode: 'bs' },
  { key: 'bai-oe', label: '百单双', pos: 0, mode: 'oe' },
  { key: 'bai-pc', label: '百质合', pos: 0, mode: 'pc' },
  { key: 'shi-pos', label: '十定位', pos: 1, mode: 'pos' },
  { key: 'shi-bs', label: '十大小', pos: 1, mode: 'bs' },
  { key: 'shi-oe', label: '十单双', pos: 1, mode: 'oe' },
  { key: 'shi-pc', label: '十质合', pos: 1, mode: 'pc' },
  { key: 'ge-pos', label: '个定位', pos: 2, mode: 'pos' },
  { key: 'ge-bs', label: '个大小', pos: 2, mode: 'bs' },
  { key: 'ge-oe', label: '个单双', pos: 2, mode: 'oe' },
  { key: 'ge-pc', label: '个质合', pos: 2, mode: 'pc' }
]

const FC3D_PRIMES = new Set([1, 2, 3, 5, 7])

function fc3dDigitTone(n) {
  return Number(n) % 2 ? 'blue' : 'red'
}

function fc3dAttrItem(mode, n) {
  if (mode === 'bs') {
    const key = n >= 5 ? '大' : '小'
    return { text: key, key, tone: key === '大' ? 'red' : 'blue' }
  }
  if (mode === 'oe') {
    const key = n % 2 ? '单' : '双'
    return { text: key, key, tone: key === '单' ? 'red' : 'blue' }
  }
  if (mode === 'pc') {
    const key = FC3D_PRIMES.has(n) ? '质' : '合'
    return { text: key, key, tone: key === '质' ? 'red' : 'blue' }
  }
  return { text: String(n), key: String(n), tone: fc3dDigitTone(n) }
}

/** 开奖序列 → 路子图节点（时间从旧到新） */
export function fc3dRoadItems(draws, filterKey) {
  const conf = ROAD_FILTERS_FC3D.find((f) => f.key === filterKey) || ROAD_FILTERS_FC3D[0]
  const chrono = [...(draws || [])].reverse()
  return chrono.map((d) => {
    const codes = (d.codes || []).map((n) => Number(n))
    if (codes.length < 3) return null
    const n = codes[conf.pos]
    if (!Number.isFinite(n) || n < 0 || n > 9) return null
    return fc3dAttrItem(conf.mode, n)
  }).filter(Boolean)
}

export function generateFc3dDraws(gameId = 14, count = 60) {
  const list = []
  let issue = 2026226
  let seed = (Number(gameId) || 14) * 7919 + 31
  const next = () => {
    seed = (seed * 1103515245 + 12345) & 0x7fffffff
    return seed % 10
  }
  for (let i = 0; i < count; i += 1) {
    list.push({
      issue: String(issue - i),
      numero: String(issue - i),
      codes: [next(), next(), next()]
    })
  }
  return list
}

